import { render } from "./NewGameDialog.vue?vue&type=template&id=ca85c3ac&scoped=true"
import script from "./NewGameDialog.vue?vue&type=script&lang=js"
export * from "./NewGameDialog.vue?vue&type=script&lang=js"

import "./NewGameDialog.vue?vue&type=style&index=0&id=ca85c3ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca85c3ac"]])

export default __exports__